module.exports = __webpack_public_path__ + "static/install-d4b0c573f1366b4514a8eadf8a0293be.png";